const CUSTOM_SIZES = {
  XS: {
    desktop: { width: 993, x: 70 },
    notebook: { width: 650, x: 70 },
    tablet: { width: 450, x: 70 }
  }
}

const DEFAULT_SIZES = {
  full: [
    { min: 1700, width: 1600, x: 85 },
    { min: 1285, width: 1350, x: 85 },
    { min: 0, width: 880, x: 85 }
  ],
  normal: [
    { min: 1700, width: 1360, x: 85 },
    { min: 1285, width: 993, x: 85 },
    { min: 0, width: 680, x: 85 }
  ]
}

const getCustomSize = (size, type) => {
  const custom = CUSTOM_SIZES[String(size)]
  return custom ? custom[type] : null
}

const checkWidthScreen = (widthScreen, callback, size, fullWidth) => {
  if (typeof callback === 'function') callback()

  const sizes = fullWidth ? DEFAULT_SIZES.full : DEFAULT_SIZES.normal
  const types = ['desktop', 'notebook', 'tablet']

  for (let i = 0; i < sizes.length; i++) {
    const { min, width, x } = sizes[i]
    if (widthScreen > min) {
      const custom = !fullWidth && getCustomSize(size, types[i])
      return custom || { width, x }
    }
  }

  const last = sizes[sizes.length - 1]
  return { width: last.width, x: last.x }
}

export { checkWidthScreen }
